import { render, staticRenderFns } from "./supplement-manage-pending.vue?vue&type=template&id=82d45aba&scoped=true"
import script from "./supplement-manage-pending.vue?vue&type=script&lang=ts"
export * from "./supplement-manage-pending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d45aba",
  null
  
)

export default component.exports